import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function CompanyProfile() {
  const { t } = useTranslation();
  const [pdfUrl] = useState("http://mapartners.ae/MA-Profile.pdf");

  return (
    <section className="relative py-[40px]">
      <div className="px-[20px]">
        <div className="flex flex-col items-center justify-center gap-[8px] text-center mb-12">
          <h2 className="text-[35px] font-bold text-[#3896BE] capitalize">
            {t("Company Profile")}
          </h2>
          <div className="flex flex-col gap-[3px] justify-center items-center">
            <span className="bg-[#3896BE] flex w-[150px] h-[4px]"></span>
            <span className="bg-[#3896BE] flex w-[250px] h-[4px]"></span>
            <span className="bg-[#3896BE] flex w-[150px] h-[4px]"></span>
          </div>
        </div>

        <div className="bg-white shadow-2xl rounded-lg p-8 relative">
          <div className="absolute left-0 top-0 bottom-0 w-4 bg-[#3896BE] rounded-l-lg"></div>
          <div className="flex flex-col items-center">
            <iframe
              src={"http://mapartners.ae/MA-Profile.pdf"}
              title="Company Profile PDF"
              className="w-full h-[800px] border-none rounded-lg shadow-md"
            />
            <Link
              to={pdfUrl}
              download="MA-Profile.pdf"
              className="mt-4 bg-[#3896BE] text-white px-6 py-2 rounded-md hover:bg-[#1A4558] transition-colors text-center"
            >
              {t("Download PDF")}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
